import React from 'react'
import Image from '../assets/images/image.png';
import { useLocation, useNavigate } from 'react-router';

const Detection = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const plantData = location.state || [];

    if (plantData.length === 0) {
        return <div>اطلاعاتی برای نمایش وجود ندارد</div>;
    }

    return (
        <div className="container mx-auto max-480 mt-154">
            {plantData.plantData.map((plant, index) => {
                const { title, common_name, image, plant_id } = plant.plantInfo;
                const percent = Math.floor(plant.percent);

                return (
                    <div 
                        key={index} 
                        className="d-flex box-detection mb-16 pointer" 
                        onClick={() => navigate(`/result/${plant_id}`)}
                    >
                        <img src={`https://app.golet.app/golet/${image}`} alt='img-plant' className='result-img' />
                        <div className="d-flex flex-direction-coulmn width-100 p-12">
                            <div className="d-flex justify-content-space-between align-items-center">
                                <div className="fs-14 fw-600">{title}</div>
                                <div className="badge-green">{Math.floor(percent)}% انطباق</div>
                            </div>

                            <div className="d-flex flex-direction-coulmn">
                                <div className="fs-12 gray-text mt-6">{common_name}</div>
                                <div className="fs-12 gray-text mt-4">سختی نگهداری : کم</div>
                            </div>
                        </div>
                    </div>
                );
            })}

            <div className="d-flex box-detection justify-content-center mt-12">
                <div className="d-flex flex-direction-coulmn p-12">
                    <div className="d-flex">
                        <div className="fs-14 fw-600">گل شما را در بین نتایج شناسایی نبود؟</div>
                    </div>

                    <div className="d-flex flex-direction-coulmn mt-24">
                        <button className="btn-not-success bg-gray black-text fw-600 pointer">راهنمای عکاسی</button>
                        <button className="btn-not-success bg-white black-text fw-600 mt-8 pointer" onClick={() => navigate('/')}>بارگزای تصویر جدید</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Detection;
